module.exports = __webpack_public_path__ + "assets/check_circle-bb3c74.svg";